export enum CaseProfiles {
  TRANSACTION_PROFILE = "TransactionProfile",
  PROVISION_PROFILE = "ProvisionProfile",
}
